<template>
  <div class="panel">
    <ProgressBar class="panel__bar" :idPodcast="podcast.id" />
    <div class="panel__wrapper">
      <AudioControlsGroup class="panel__control" :idPodcast="podcast.id" />
      <TimeIndicator class="panel__time" :currentTime="currentTimeFormat" :durationTime="durationTimeAudioFormat" :adjustedRemainingTime="adjustedRemainingTimeFormat"/>
      <div class="panel__timecode" ref="timecodeDropdown">
        <TimecodesListButton :text="podcast.timecodes[currentTimecodeId]" @click="toggleTimecodesDropdown"/>
        <transition name="animation-fade-up">
          <div class="panel__timecode-dropdown" v-if="isTimecodesDropdownOpen">
            <TimecodesList :idPodcast="podcast.id" />
          </div>
        </transition>
      </div>
      <div></div>
      <div class="panel__current-podcast" @click="openContent()">
        <CurrentPodcast v-if=" postWithActivePlayer">{{ postWithActivePlayer.title }}</CurrentPodcast>
      </div>
      <SpeedStatus class="panel__speed" />
      <VolumeStatus class="panel__volume" />
      <CloseButton class="panel__close" @click="closePanel()"/>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';
  import { useAudioPlayerState } from '../../composables/computedValues';
  import { useContentPopup } from '../../imports/callContentPopup';
  //-------------------------------------
  import AudioControlsGroup from '../AudioControlsGroup/AudioControlsGroup.vue';
  import TimeIndicator from '../../ui/TimeIndicator/TimeIndicator.vue';
  import CloseButton from '../../ui/CloseButton/CloseButton.vue';
  import VolumeStatus from '../VolumeStatus/VolumeStatus.vue';
  import SpeedStatus from '../SpeedStatus/SpeedStatus.vue';
  import ProgressBar from '../ProgressBar/ProgressBar.vue';
  import TimecodesListButton from '../../ui/TimecodesListButton/TimecodesListButton.vue';
  import CurrentPodcast from '@/Groups/Audioplayer/private/ui/CurrentPodcast/CurrentPodcast.vue';
  import TimecodesList from '../TimecodesList/TimecodesList.vue';
  //-------------------------------------
  const store = useStore();
  //-------------------------------------
  const { podcast, currentTimeFormat, durationTimeAudioFormat, adjustedRemainingTimeFormat, currentTimecodeId } = useAudioPlayerState();
  //-------------------------------------
  const { postWithActivePlayer, openContentPopup } = useContentPopup();
  //-------------------------------------
  const isTimecodesDropdownOpen = ref(false);
  const timecodeDropdown = ref(null);
  //-------------------------------------
  onMounted(() => {
    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('keydown', handleKeydown);
    document.removeEventListener('click', handleClickOutside);
  });
  //-------------------------------------
  //Открыть попап с контентом
  const openContent = () => {
    if(!podcast.value) return;
    openContentPopup(podcast.value.object_id);
  }
  //Закрыть панель
  const closePanel = () => store.dispatch('Audioplayer/closeStickyPanel', false);
  //Переключение видимости дропдауна с таймкодами
  const toggleTimecodesDropdown = () => {
    isTimecodesDropdownOpen.value = !isTimecodesDropdownOpen.value;
  };
  //Закрытие при нажатии Esc
  const handleKeydown = (e) => {
    if (e.key === 'Escape') {
      isTimecodesDropdownOpen.value = false;
    }
  };
  //Клик вне области
  const handleClickOutside = (event) => {
    if (timecodeDropdown.value && !timecodeDropdown.value.contains(event.target)) {
      isTimecodesDropdownOpen.value = false;
    }
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>
